import baseEditForm from 'formiojs/components/_classes/component/Component.form';

import DateTimeEditData from 'formiojs/components/datetime/editForm/DateTime.edit.data';
import DateTimeEditDisplay from 'formiojs/components/datetime/editForm/DateTime.edit.display';
import DateTimeEditValidation from 'formiojs/components/datetime/editForm/DateTime.edit.validation';

export default (...extend) => baseEditForm(
  [
    {
      key: 'display',
      components: DateTimeEditDisplay,
    },
    {
      key: 'data',
      components: DateTimeEditData,
    },
    {
      key: 'validation',
      components: DateTimeEditValidation,
    },
    {
      key: 'addons',
      ignore: true,
    },
    {
      label: 'Custom',
      key: 'custom',
      components: [
        {
          weight: 50,
          type: 'checkbox',
          label: 'Hide Custom Label',
          tooltip: 'Hide the label (title, if no label) of this component. This allows you to show/hide the custom label when it is rendered.',
          key: 'hideCustomLabel',
          input: true,
        },
        {
          weight: 100,
          type: 'checkbox',
          label: 'Min Date',
          key: 'minDateCheckbox',
          defaultValue: false,
          input: true,
        },
        {
          weight: 150,
          type: 'checkbox',
          label: 'Max Date',
          key: 'maxDateCheckbox',
          defaultValue: false,
          input: true,
        },
        {
          weight: 200,
          type: 'textfield',
          label: 'Tooltip Title',
          key: 'tooltipTitle',
          input: true,
        }],
    },
    {
      label: 'Review',
      key: 'review',
      components: [
        {
          weight: 50,
          type: 'checkbox',
          label: 'Use Custom Label',
          tooltip:
              'Use custom label for this component on the review page.',
          key: 'useReviewLabel',
          input: true,
        },
        {
          weight: 100,
          type: 'textfield',
          label: 'Review Page Label',
          key: 'reviewLabel',
          input: true,
        },
      ],
    },
  ],
  ...extend,
);
